export default {"src":"/_next/static/media/wishlist-fill.812fed3b.svg","height":24,"width":24};